import { Badge, Group, Text } from "@/components/ui";
import type { EstadoPago } from "../services/calendario-pagos.api";

/** Semáforo con significado EXPLÍCITO (el portal viejo pintaba rojo sin leyenda). */
export const SEMAFORO: Record<EstadoPago, { color: string; label: string; descripcion: string }> = {
  Vencido: {
    color: "peligro",
    label: "Vencido",
    descripcion: "La fecha de pago ya pasó y la póliza no se ha depositado.",
  },
  PagaHoy: {
    color: "advertencia",
    label: "Paga hoy",
    descripcion: "La fecha de pago es hoy.",
  },
  Programado: {
    color: "slate",
    label: "Programado",
    descripcion: "Fecha de pago futura · en calendario.",
  },
  Depositado: {
    color: "exito",
    label: "Depositado",
    descripcion: "La póliza ya se depositó (SFTP/local).",
  },
};

export function SemaforoPagoBadge({ estado }: { estado: EstadoPago }) {
  const s = SEMAFORO[estado] ?? SEMAFORO.Programado;
  return (
    <Badge variant="light" color={s.color} size="sm">
      {s.label}
    </Badge>
  );
}

/** Leyenda del semáforo · siempre visible bajo la tabla/calendario. */
export function SemaforoLeyenda() {
  return (
    <Group gap="md" className="flex-wrap">
      {Object.entries(SEMAFORO).map(([k, s]) => (
        <Group key={k} gap={6} className="flex-nowrap">
          <Badge variant="light" color={s.color} size="xs">
            {s.label}
          </Badge>
          <Text size="xs" c="dimmed">
            {s.descripcion}
          </Text>
        </Group>
      ))}
    </Group>
  );
}
